import { PeekButton, PeekDialog, PeekDialogActions, PeekDialogContent, PeekTypography, } from "@piiqtechnologies/ui-components";
import { useAnalytics, useError, useLoader, useNotification, useRefetch, useUnpublishFromGMB, } from "@piiqtechnologies/ui-lib";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const SpaceUnpublishToGMBDialog = ({ spaceId, open, onClose, spaceType }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    const analytics = useAnalytics();
    const [unpublishFromGMB, unpublishedFromGMB, unpublishFromGMBInProgress, unpublishFromGMBError] = useUnpublishFromGMB();
    useEffect(() => {
        setLoader(unpublishFromGMBInProgress, "unpublishFromGMBInProgress");
        return () => setLoader(false);
    }, [unpublishFromGMBInProgress]);
    useEffect(() => {
        if (unpublishFromGMBError) {
            setError(unpublishFromGMBError === null || unpublishFromGMBError === void 0 ? void 0 : unpublishFromGMBError.message);
        }
    }, [unpublishFromGMBError]);
    useEffect(() => {
        if (unpublishedFromGMB) {
            setNotification(intl.formatMessage(messages.spaceUnpublishToGMBSuccess));
            analytics.track("Unpublish From GMB");
            setRefetch();
        }
    }, [unpublishedFromGMB]);
    const onUnpublishToGMB = () => {
        unpublishFromGMB(spaceId);
    };
    return (React.createElement(PeekDialog, { maxWidth: "xs", fullWidth: true, hasCloseIcon: true, title: intl.formatMessage(messages.spaceUnpublishToGMBTitle), open: open, onClose: onClose },
        React.createElement(PeekDialogContent, null,
            React.createElement(PeekTypography, { textAlign: "left" }, intl.formatMessage(messages.spaceUnpublishToGMBFormConfimation))),
        React.createElement(PeekDialogActions, null,
            React.createElement(PeekButton, { size: "large", fullWidth: true, color: "primary", variant: "outlined", onClick: onClose }, intl.formatMessage(messages.spaceUnpublishToGMBCancelButton)),
            React.createElement(PeekButton, { size: "large", fullWidth: true, color: "error", variant: "contained", onClick: onUnpublishToGMB }, intl.formatMessage(messages.spaceUnpublishToGMBButton)))));
};
export default SpaceUnpublishToGMBDialog;
